import { CoreServiceUrls } from "../../apis/core-service-urls";
import { DataGateWayUrls } from "../../apis/data-gateway-urls";
import { Pick_A, Pick_AA } from "../../fixtures/utilityFixtures";
import Fetch from "../../utils/request-provider/Fetch";
import { IDetailViewLayoutResponse } from "./detailed-view/DetailedView.d";
import { ISelectedFilter } from "./detailed-view/tabs-component/TabsComponent.d";
import { TOrderFilterRequestParams } from "./fixtures";
import { ColumnType } from "./table-tabs/OrderListingTable/OrderListingTable.d";

const getFactoryId = () => {
	if (process.env.NODE_ENV === "development") {
		return "ind-pemp-p122";
	}
	return (window as any).getUserDetails().factoryId;
};

export const fetchOrderLayOut = async (): Promise<TOrderModuleLayout> => {
	return await (
		await Fetch.get(`${DataGateWayUrls.FETCH_ORDER_LAYOUT}/${getFactoryId()}`)
	).data;
};

export const fetchOrderFilters = async (
	requestParams: TOrderFilterRequestParams
): Promise<TOrderFieldFilter> => {
	return await (
		await Fetch.post(CoreServiceUrls.FETCH_ORDER_FILTER, {
			...requestParams,
			factoryId: getFactoryId(),
		})
	).data;
};

export const fetchOrderData = async (
	requestParams: IOrderRequestDTO
): Promise<TOrderTableData> => {
	return await (
		await Fetch.post(DataGateWayUrls.FETCH_ORDER_DATA, {
			...requestParams,
			subjectKey: getFactoryId(),
		})
	).data;
};

export const fetchDetailLayout = async (): Promise<IDetailViewLayoutResponse> => {
	const response = await Fetch.get(`${DataGateWayUrls.FETCH_DETAIL_LAYOUT}/${getFactoryId()}`);
	return response.data;
};

export const fetchDetailData = async (
	requestParams: IDetailDataFetchDTO
): Promise<any> => {
		const response = await Fetch.post(DataGateWayUrls.FETCH_DETAIL_DATA, {
			...requestParams,
			subjectKey: getFactoryId(),
		});
		return response.data;
};

export type TOrderTableData = typeof orderTableData;

const orderTableData = {
	rows: [
		{
			orderShippableId: "5fbfb6a0acec944f58649f62ed99ded1",
			buyer: "Buyer1",
			style: "style 1",
			po: "po 1",
			ocs_no: "ocsNo1",
			erpKey: "erpKey 1",
			deliveryDate: "delivery date 1",
			destination: "destination",
			totalQty: 220,
			progress: {
				completedQty: 15,
				wipQty: 20,
				notStartedQty: 4,
			},
		},
	],
	total: 1,
};

const orderFilterData = {
	orderFields: { buyer: ["a", "b"], style: ["a", "c"], po: ["a"] },
};
export type TOrderFieldFilter = typeof orderFilterData;

export type TFilterData = Pick_A<TOrderFieldFilter, "orderFields">;

export interface IOrderRequestDTO {
	subjectKey: String;
	filters: RequestFilter[];
	startDate: string;
	endDate: string;
	tabType: TOrderTabTypes;
	pageIndex: number;
	limit: number;
}

export interface IDetailDataFetchDTO {
	shippableId: string;
	componentRequests: Array<{ componentId: string, filters: Array<ISelectedFilter>}>;
}

export type TOrderTabTypes = "in_progress" | "not_started" | "completed";
export type TFilterTypes = "BCTX_FILTER" | "DATE_FILTERS";

interface RequestFilter {
	key: string;
	values: string[];
}

export const orderModuleConfig = {
	tabTypes: [
		{
			title: "In Progress",
			tabType: "in_progress" as TOrderTabTypes,
			orderDetailViewPresent: true,
			columnMetaData: [
				{
					columnDisplayName: "BUYER",
					columnIndex: 0,
					type: "STRING",
					columnJsonKey: "buyer",
				},
				{
					columnDisplayName: "STYLE",
					columnIndex: 1,
					type: "STRING",
					columnJsonKey: "style",
				},
				{
					columnJsonKeys: [
						{
							columnDisplayName: "PO",
							columnIndex: 0,
							columnJsonKey: "po",
						},
						{
							columnDisplayName: "OCS NO",
							columnIndex: 1,
							columnJsonKey: "erpKey",
						},
					],
					columnIndex: 2,
					type: "MERGED",
				},
				{
					columnDisplayName: "DELIVERY",
					columnIndex: 3,
					type: "STRING",
					columnJsonKey: "deliveryDate",
				},
				{
					columnDisplayName: "DESTINATION",
					columnIndex: 4,
					type: "STRING",
					columnJsonKey: "destination",
				},
				{
					columnDisplayName: "TOTAL QTY",
					columnIndex: 5,
					type: "NUMBER",
					columnJsonKey: "totalQty",
				},
				{
					columnDisplayName: "PROGRESS",
					columnJsonKeys: [
						{ columnIndex: 0, columnJsonKey: "completedQty" },
						{ columnIndex: 1, columnJsonKey: "wipQty" },
						{ columnIndex: 2, columnJsonKey: "notStartedQty" },
					],
					columnIndex: 6,
					type: "PROGRESS",
				},
			],
			tabFilters: [
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "buyer",
					displayName: "BUYER",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "PO",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "STYLE",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "destination",
					displayName: "DESTINATION",
				},
				{
					filterType: "DATE_FILTERS" as TFilterTypes,
					key: "delivery_date",
				},
			],
		},
		{
			title: "Not started",
			tabType: "not_started" as TOrderTabTypes,
			orderDetailViewPresent: false,
			columnMetaData: [
				{
					columnDisplayName: "BUYER",
					columnIndex: 0,
					type: "STRING",
					columnJsonKey: "buyer",
				},
				{
					columnDisplayName: "STYLE",
					columnIndex: 1,
					type: "STRING",
					columnJsonKey: "style",
				},
				{
					columnJsonKeys: [
						{
							columnDisplayName: "PO",
							columnIndex: 0,
							columnJsonKey: "po",
						},
						{
							columnDisplayName: "OCS NO",
							columnIndex: 1,
							columnJsonKey: "erpKey",
						},
					],
					columnIndex: 2,
					type: "MERGED",
				},
				{
					columnDisplayName: "DELIVERY",
					columnIndex: 3,
					type: "STRING",
					columnJsonKey: "deliveryDate",
				},
				{
					columnDisplayName: "DESTINATION",
					columnIndex: 4,
					type: "STRING",
					columnJsonKey: "destination",
				},
				{
					columnDisplayName: "TOTAL QTY",
					columnIndex: 5,
					type: "NUMBER",
					columnJsonKey: "totalQty",
				},
				{
					columnDisplayName: "PROGRESS",
					columnJsonKeys: [
						{ columnIndex: 0, columnJsonKey: "completedQty" },
						{ columnIndex: 1, columnJsonKey: "wipQty" },
						{ columnIndex: 2, columnJsonKey: "notStartedQty" },
					],
					columnIndex: 6,
					type: "PROGRESS",
				},
			],
			tabFilters: [
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "buyer",
					displayName: "BUYER",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "PO",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "STYLE",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "destination",
					displayName: "DESTINATION",
				},
				{
					filterType: "DATE_FILTERS" as TFilterTypes,
					key: "delivery_date",
				},
			],
		},
		{
			title: "Closed",
			tabType: "completed" as TOrderTabTypes,
			orderDetailViewPresent: true,
			columnMetaData: [
				{
					columnDisplayName: "BUYER",
					columnIndex: 0,
					type: "STRING",
					columnJsonKey: "buyer",
				},
				{
					columnDisplayName: "STYLE",
					columnIndex: 1,
					type: "STRING",
					columnJsonKey: "style",
				},
				{
					columnJsonKeys: [
						{
							columnDisplayName: "PO",
							columnIndex: 0,
							columnJsonKey: "po",
						},
						{
							columnDisplayName: "OCS NO",
							columnIndex: 1,
							columnJsonKey: "erpKey",
						},
					],
					columnIndex: 2,
					type: "MERGED",
				},
				{
					columnDisplayName: "DELIVERY",
					columnIndex: 3,
					type: "STRING",
					columnJsonKey: "deliveryDate",
				},
				{
					columnDisplayName: "DESTINATION",
					columnIndex: 4,
					type: "STRING",
					columnJsonKey: "destination",
				},
				{
					columnDisplayName: "TOTAL QTY",
					columnIndex: 5,
					type: "NUMBER",
					columnJsonKey: "totalQty",
				},
				{
					columnDisplayName: "PROGRESS",
					columnJsonKeys: [
						{ columnIndex: 0, columnJsonKey: "completedQty" },
						{ columnIndex: 1, columnJsonKey: "wipQty" },
						{ columnIndex: 2, columnJsonKey: "notStartedQty" },
					],
					columnIndex: 6,
					type: "PROGRESS",
				},
			],
			tabFilters: [
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "buyer",
					displayName: "BUYER",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "PO",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "po",
					displayName: "STYLE",
				},
				{
					filterType: "BCTX_FILTER" as TFilterTypes,
					key: "destination",
					displayName: "DESTINATION",
				},
				{
					filterType: "DATE_FILTERS" as TFilterTypes,
					key: "delivery_date",
				},
			],
		},
	],
};

export type TOrderModuleLayout = typeof orderModuleConfig;
export type TTabAPI = Pick_AA<TOrderModuleLayout, "tabTypes", 0>;
export type TFilterAPIConfig = Pick_A<TTabAPI, "tabFilters">[number];

export interface IColumnMetaData {
	columnDisplayName: string;
	type: ColumnType;
	columnJsonKey?: string;
	columnJsonKeys?: Array<IMergedColumnMetaData>;
	columnIndex: number;
}

export interface IMergedColumnMetaData {
	columnDisplayName: string;
	columnJsonKey: string;
	columnIndex: number;
}

export interface IProgressColumnMetaData {
	columnJsonKey: string;
	columnIndex: number;
}
